/**
 * @generated SignedSource<<206fb3c788e5122439dad9800e9dd0c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SheetRenderer_piece$data = {
  readonly id: string;
  readonly file: {
    readonly notes: ReadonlyArray<{
      readonly bulb_id: string;
      readonly " $fragmentSpreads": FragmentRefs<"SheetRendererNote_note">;
    }>;
  } | null;
  readonly sheets: ReadonlyArray<{
    readonly id: string;
    readonly width: number;
    readonly height: number;
    readonly thumbnail_download_url: string;
  }>;
  readonly " $fragmentType": "SheetRenderer_piece";
};
export type SheetRenderer_piece$key = {
  readonly " $data"?: SheetRenderer_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"SheetRenderer_piece">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SheetRenderer_piece",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicPieceFile",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MusicPieceFileNote",
          "kind": "LinkedField",
          "name": "notes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bulb_id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SheetRendererNote_note"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicSheet",
      "kind": "LinkedField",
      "name": "sheets",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnail_download_url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};
})();

(node as any).hash = "1165675426af9b8d16f1f16723374d12";

export default node;
